module.exports = __webpack_public_path__ + "img/main-logo.8e2f6a8c.png";